"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentAclActorType = exports.DocumentAclAccess = exports.DocumentPermission = void 0;
var DocumentPermission;
(function (DocumentPermission) {
    DocumentPermission["READ"] = "read";
    DocumentPermission["WRITE"] = "write";
    DocumentPermission["DELETE"] = "delete";
    DocumentPermission["MANAGE"] = "manage";
})(DocumentPermission || (exports.DocumentPermission = DocumentPermission = {}));
var DocumentAclAccess;
(function (DocumentAclAccess) {
    DocumentAclAccess["ALLOW"] = "allow";
    DocumentAclAccess["DENY"] = "deny";
})(DocumentAclAccess || (exports.DocumentAclAccess = DocumentAclAccess = {}));
var DocumentAclActorType;
(function (DocumentAclActorType) {
    DocumentAclActorType["USER"] = "user";
    DocumentAclActorType["COMPANY"] = "company";
    DocumentAclActorType["SYSTEM"] = "system";
})(DocumentAclActorType || (exports.DocumentAclActorType = DocumentAclActorType = {}));
//# sourceMappingURL=documentPermission.enum.js.map